module.exports = __webpack_public_path__ + "img/carousel-mobile-4.b85e89dd.svg";